import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {item.href && !isLast ? (
                <Link
                  to={item.href}
                  className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  className={`whitespace-nowrap ${
                    isLast ? 'text-foreground-900 font-medium' : 'text-foreground-500'
                  }`}
                >
                  {item.label}
                </span>
              )}
              {!isLast && (
                <span className="text-foreground-400 mx-1">
                  <i className="ri-arrow-right-s-line text-sm"></i>
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}